import { pinyin } from 'pinyin-pro';

const roi_menus = {
  en: {
    '-100': { label: 'All', value: -100, role_id: -1 },
    '-1': { label: 'Xcube-Tech Gallery', value: -1, role_id: 0 },
    '-2': { label: 'Group Gallery', value: -2, role_id: -1 },
    '-3': { label: 'Favorite Gallery', value: -3, role_id: 0 },
    '-5': { label: 'AI', value: -5, role_id: -1 },
    '-4': { label: 'HI', value: -4, role_id: -1 }
  },
  zh: {
    '-100': { label: '全部图像', value: -100, role_id: -1 },
    '-1': { label: 'Xcube参考库', value: -1, role_id: 0 },
    ///"-2": {'label': '致灾参考库', value: -2, 'role_id': -1 },
    '-2': { label: '团队参考库', value: -2, role_id: -1 },
    '-3': { label: '集萃墙', value: -3, role_id: 0 },
    '-5': { label: '机器识别', value: -5, role_id: -1 },
    '-4': { label: '人工识别', value: -4, role_id: -1 }
  }
};
const sys_lang = ['中文', 'English'];

const getRole = function (t, callback) {
  t.$axios.get('setting/get-role', { params: { language: localStorage.getItem('ipp_lang') } }).then(res => {
    callback(res);
  });
};
const getSys = function (t, callback) {
  t.$axios.get('tool/sys-init', { params: { language: localStorage.getItem('ipp_lang'), sort: '-title' } }).then(res => {
    // 暂时修改，role_idP: 0 方便测试功能
    callback({ ...res, data: { ...res.data } });
  });
};

// 获取完整大小单位
const fixRoiSize = size => {
  if (size > 1000 * 1224) {
    return { uni: 'MB', size: (size / (1024 * 1000)).toFixed(0) };
  } else {
    return { uni: 'KB', size: (size / 1024).toFixed(0) };
  }
};

// 获取完整数量单位
const fixCountUnit = (c, w, u) => {
  if (c < 10000) {
    return c + u;
  } else {
    return (c / 10000).toFixed(2) + w + u;
  }
};

// 判断当前页面是否被 iframe 嵌入
function isInIframe() {
  // 如果 window !== window.top，说明页面被嵌入在 iframe 中
  return window !== window.top;
}

// 获取完整图片地址
const onGetImageUrl = url => {
  if (!url) return '';
  if (url.includes('http')) return url;
  // 如果是本地开发 使用 固定IP，如果是线上版本则使用浏览器地址
  if (process.env.NODE_ENV === 'development') {
    return 'http://ippconsole.com/api/' + url;
  } else {
    if (isInIframe()) {
      // 获取子页面自身的域名相关信息
      const subDomain = {
        hostname: window.location.hostname, // 域名（不含端口）
        host: window.location.host, // 域名+端口
        origin: window.location.origin // 完整源（协议+域名+端口）
      };

      console.log('子页面自身域名（hostname）：', subDomain.hostname);
      console.log('子页面完整 host（域名+端口）：', subDomain.host);
      console.log('子页面完整 origin：', subDomain.origin);

      const roiUrl = window.location.origin + '/api/' + url;

      // 原字符串中需要替换的部分
      const original = 'https://hysjzx.gzlpc.gov.cn/api/';
      // 替换后的新内容
      const replacement = 'https://hysjzx.gzlpc.gov.cn/fyswtp/api/';
      // 执行替换（使用正则确保全局替换所有匹配项）
      return roiUrl.replace(new RegExp(original, 'g'), replacement);
    }

    return window.location.origin + '/api/' + url;
  }
};

// 首字母排序
const sortByFirstLetter = (arr, title = 'title', sort = 'asc') => {
  if (!arr) return [];
  const a = arr.sort((a, b) => {
    const pinyinA = pinyin(a[title][0], { pattern: 'first' }).toUpperCase();
    const pinyinB = pinyin(b[title][0], { pattern: 'first' }).toUpperCase();
    if (pinyinA < pinyinB) {
      return sort === 'asc' ? -1 : 1;
    }
    if (pinyinA > pinyinB) {
      return sort === 'asc' ? 1 : -1;
    }
    return 0;
  });

  return a;
};

export default {
  getRole,
  getSys,
  fixRoiSize,
  fixCountUnit,
  sortByFirstLetter,
  onGetImageUrl
};
